import dynamic from "next/dynamic";

export const DynamicHero037 = dynamic(() => import("./Hero037"), {
  suspense: true,
});
